import { render, staticRenderFns } from "./MenuEstaticoItemView.vue?vue&type=template&id=b3d6c5f6&scoped=true&"
import script from "./MenuEstaticoItemView.vue?vue&type=script&lang=js&"
export * from "./MenuEstaticoItemView.vue?vue&type=script&lang=js&"
import style0 from "./MenuEstaticoItemView.vue?vue&type=style&index=0&id=b3d6c5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d6c5f6",
  null
  
)

export default component.exports